import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { Press as PressContent } from 'Press';

export const Press = () => {
  return (
    <AppLayout>
      <PressContent />
    </AppLayout>
  );
};

export default Press;
